module.exports = __webpack_public_path__ + "img/competition-egenting-1-2018.0db01f5d.png";